var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1999 3.19961C3.1999 2.31595 3.91625 1.59961 4.7999 1.59961H8.46853C8.89288 1.59961 9.29984 1.76818 9.5999 2.06824L12.3313 4.79961C12.6313 5.09967 12.7999 5.50663 12.7999 5.93098V12.7996C12.7999 13.6833 12.0836 14.3996 11.1999 14.3996H9.97767C10.7377 13.5504 11.1999 12.429 11.1999 11.1996C11.1999 8.54864 9.05087 6.39961 6.3999 6.39961C5.17054 6.39961 4.04911 6.86177 3.1999 7.62184V3.19961Z",
    fill: "url(#paint0_linear_258_207)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3999 7.99961C4.63259 7.99961 3.1999 9.4323 3.1999 11.1996C3.1999 11.7927 3.36174 12.3487 3.64308 12.8251L2.63422 13.8339C2.3218 14.1463 2.3218 14.6529 2.63422 14.9653C2.94664 15.2777 3.45317 15.2777 3.76559 14.9653L4.77445 13.9564C5.2508 14.2378 5.8068 14.3996 6.3999 14.3996C8.16721 14.3996 9.5999 12.9669 9.5999 11.1996C9.5999 9.4323 8.16721 7.99961 6.3999 7.99961ZM4.7999 11.1996C4.7999 10.316 5.51625 9.59961 6.3999 9.59961C7.28356 9.59961 7.9999 10.316 7.9999 11.1996C7.9999 12.0833 7.28356 12.7996 6.3999 12.7996C5.95785 12.7996 5.55895 12.6214 5.26853 12.331C4.97811 12.0406 4.7999 11.6417 4.7999 11.1996Z",
    fill: "url(#paint1_linear_258_207)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_207",
    x1: 2.3999,
    y1: 1.59961,
    x2: 15.5248,
    y2: 11.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2375D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF3B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_207",
    x1: 2.3999,
    y1: 1.59961,
    x2: 15.5248,
    y2: 11.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2375D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF3B65"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearch);
export default __webpack_public_path__ + "static/media/document-search.56adb0b5acba4c52becb258f5ab58d58.svg";
export { ForwardRef as ReactComponent };